module.exports = __webpack_public_path__ + "static/media/Sport1-Regular.65b4d832.ttf";